import { Component, OnInit, OnDestroy } from '@angular/core';
import { StreamService } from '../services';
import { takeUntil, tap, filter, flatMap} from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, BehaviorSubject } from 'rxjs';

@Component({
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center" style="padding-top: 50px;"><spinner></spinner></div>
        <div *ngIf="!noTouching" fxLayoutAlign="center center">
            <h3 style="margin-bottom: 3px;">Featured</h3>
        </div>
        <non-scrolling-topic-summary-grid *ngIf="!noTouching" 
                                          [topics]="topics" 
                                          emptyMessage="Your team hasn't created topics yet.">
        </non-scrolling-topic-summary-grid>
    `
})
export class BrowseFeaturedTopicsPane implements OnInit, OnDestroy {
    noTouching = true;
    params = new BehaviorSubject<any>(null);
    topics: any[];
    cleanupTime = new Subject<void>();

    constructor(private streamService: StreamService, private route: ActivatedRoute, private router: Router) {}

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.topics = [];
            this.params.next({ 
                includeCatalogs: false,
                published: true,
                featured: true,
                page: 0,
                rows: 40,
                sort: this.route.snapshot.queryParams.sort || 'titleLower',
                sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc'
            });
        });
        this.params.next({ 
            includeCatalogs: false,
            published: true,
            featured: true,
            page: 0,
            rows: 40,
            sort: this.route.snapshot.queryParams.sort || 'titleLower',
            sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc'
        });

        this.params.pipe(
            filter(params => !!params),
            flatMap(params => this.streamService.getTenantStreams(params)),
            tap(() => this.noTouching = false),
            takeUntil(this.cleanupTime)
        ).subscribe(userTopicResults => {
            this.topics = this.topics.concat(userTopicResults.content);
            if (!this.topics.length) {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { isEmpty: 'true' },
                    queryParamsHandling: 'merge'
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
